import {h, Fragment} from "preact"
export default function Checkbox({ value, selected, onChange, className }) {
    let displayValue = value;

    if (typeof value === "string" && /[[\]"]/.test(value)) {
        displayValue = value.replace(/[[\]"]/g, "");
    }

    return (
        <label className={`ns-checkbox ns-color-black facets__label facet-checkbox active ${className}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
            <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect width="24" height="24" stroke="currentColor" fill="none" stroke-width="1"></rect></svg>
            <svg width="1.8rem" height="1.8rem" viewBox="0 0 18 18" aria-hidden="true" class="icon icon-checkmark"><rect width="18" height="18" fill="#050505"></rect></svg>
            <span class="facet-checkbox__text nosto">
                {displayValue}
            </span>
        </label>
    )
}